import React from "react";

export const WhatsAppLinkButton = () => {
  const whatsappLink = "https://api.whatsapp.com/send/?phone=310103072889";

  return (
    <a
      href={whatsappLink}
      target="_blank"
      className="gg-ml-auto gg-whitespace-nowrap gg-rounded-[3px] gg-bg-green-900 gg-px-4 gg-py-2 gg-text-center gg-text-sm gg-font-bold gg-leading-[160%] gg-text-white hover:gg-bg-[#083f35] sm:gg-whitespace-normal"
      rel="noreferrer"
    >
      Stuur een bericht
    </a>
  );
};
